module.exports = __webpack_public_path__ + "./img/export_icon.svg";